import React from "react";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import DynamicMetaTags from "./components/DynamicMetaTags";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import TeamSection from "./components/TeamSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <DynamicMetaTags />
      <div className="App">
        <Navigation />
        <HeroSection />
        <TeamSection />
        <AboutSection />
        <ContactSection />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;